export default {
  methods: {
    translateCategory(key) {
      if (!key) return '';
      const formattedKey = key.toLowerCase().replace(/-/g, '_');
      return this.$t(`general.${formattedKey}`);
    },
  },
};
